import React, { createContext, useContext, useState } from "react";

const VendedorContext = createContext();

export const VendedorContextProvider = ({ children }) => {

  const [idVendedor, setIdVendedor] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [nomeVendedor, setNomeVendedor] = useState(

  )

  const value = {
    idVendedor,
    setIdVendedor,
    openDialog,
    setOpenDialog,
    nomeVendedor,
    setNomeVendedor
  }

  return (
    <VendedorContext.Provider value={value}>
      {children}
    </VendedorContext.Provider>
  )
}

export const useVendedorContext = () => {
  const context = useContext(VendedorContext);
  if (!context) {
    throw new Error('useProductContext deve ser usado com um ProdutoProvider');
  }
  return context
}